(function () {
  var form = document.querySelector('[data-zm-ss]');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = '1';

  var input = form.querySelector('input[name="q"]');
  var panel = form.querySelector('.zm-ss-panel');
  var clearBtn = form.querySelector('.zm-ss-clear');
  var html = document.documentElement;
  var mobile = window.matchMedia('(max-width: 980px)');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var money = form.dataset.money || 'Rs. {{amount}}';
  var popular = (form.dataset.popular || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var KEY = 'zmRecent';
  var ALIAS = {
    kanjivaram: 'kanchipuram', kanjeevaram: 'kanchipuram', kancheepuram: 'kanchipuram', kanchivaram: 'kanchipuram',
    banarsi: 'banarasi', benarasi: 'banarasi', banaras: 'banarasi', benaras: 'banarasi', varanasi: 'banarasi',
    organja: 'organza', cottan: 'cotton', mashroo: 'mashru', kattan: 'katan',
    sari: 'saree', saari: 'saree', sadi: 'saree', saris: 'sarees',
    bridal: 'wedding', marriage: 'wedding', shaadi: 'wedding', shadi: 'wedding'
  };
  var cache = {};
  var seq = 0;
  var timer = 0;
  var ctrl = null;
  var open = false;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mark(text, terms) {
    var out = esc(text);
    if (!terms.length) return out;
    var re = new RegExp('(' + terms.map(function (t) { return esc(t).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'gi');
    return out.replace(re, '<mark>$1</mark>');
  }

  function fmt(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    return money.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var euro = /comma_separator/.test(key);
      var parts = n.toFixed(/no_decimals/.test(key) ? 0 : 2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, euro ? '.' : ',');
      return parts.join(euro ? ',' : '.');
    });
  }

  function recent() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function remember(q) {
    q = q.trim();
    if (q.length < 2) return;
    var list = recent().filter(function (r) { return r.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  }

  /* "red kanjivaram under 2000" -> { q: "red kanchipuram", max: 2000, fixed: true } */
  function understand(raw) {
    var q = ' ' + raw.toLowerCase() + ' ';
    var out = { q: '', min: 0, max: 0, fixed: false };
    q = q.replace(/\b(?:under|below|less than|upto|up to|within|max)\s*(?:rs\.?|inr|₹)?\s*(\d[\d,]*)\s*(k)?\b/, function (_, n, k) {
      out.max = parseInt(n.replace(/,/g, ''), 10) * (k ? 1000 : 1);
      return ' ';
    });
    q = q.replace(/\b(?:above|over|more than|from|min)\s*(?:rs\.?|inr|₹)?\s*(\d[\d,]*)\s*(k)?\b/, function (_, n, k) {
      out.min = parseInt(n.replace(/,/g, ''), 10) * (k ? 1000 : 1);
      return ' ';
    });
    q = q.replace(/₹/g, ' ').split(/\s+/).filter(Boolean).map(function (w) {
      if (ALIAS[w]) { out.fixed = true; return ALIAS[w]; }
      return w;
    }).join(' ');
    out.q = q || ((out.min || out.max) ? 'saree' : '');
    return out;
  }

  function resultsUrl(intent) {
    var p = new URLSearchParams();
    p.set('q', intent.q);
    p.set('type', 'product');
    p.set('options[prefix]', 'last');
    if (intent.min) p.set('filter.v.price.gte', intent.min);
    if (intent.max) p.set('filter.v.price.lte', intent.max);
    return root + 'search?' + p.toString();
  }

  function suggest(q) {
    var p = new URLSearchParams();
    p.set('q', q);
    p.set('resources[type]', 'product,collection,query,page');
    p.set('resources[limit]', '10');
    p.set('resources[limit_scope]', 'each');
    p.set('resources[options][unavailable_products]', 'last');
    p.set('resources[options][fields]', 'title,product_type,variants.title,tag');
    var url = root + 'search/suggest.json?' + p.toString();
    if (cache[url]) return Promise.resolve(cache[url]);
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { cache[url] = d.resources.results; return cache[url]; });
  }

  function chip(text, cls) {
    return '<a class="zm-ss-chip' + (cls ? ' ' + cls : '') + '" role="option" href="' + esc(resultsUrl(understand(text))) + '" data-fill="' + esc(text) + '">' + esc(text) + '</a>';
  }

  function group(label, body, cls) {
    return '<div class="zm-ss-group' + (cls ? ' ' + cls : '') + '" role="group" aria-label="' + esc(label) + '"><p class="zm-ss-h" aria-hidden="true">' + esc(label) + '</p>' + body + '</div>';
  }

  function idle() {
    var r = recent();
    var out = '';
    if (r.length) {
      out += '<div class="zm-ss-group" role="group" aria-label="Recent searches"><p class="zm-ss-h" aria-hidden="true">Recent <button type="button" class="zm-ss-forget">Clear</button></p><div class="zm-ss-chips">' + r.map(function (t) { return chip(t, 'is-recent'); }).join('') + '</div></div>';
    }
    if (popular.length) out += group('Popular', '<div class="zm-ss-chips">' + popular.map(function (t) { return chip(t); }).join('') + '</div>');
    out += '<p class="zm-ss-tip">Try a colour, a weave or a budget, like <em>red silk under 2000</em>.</p>';
    return out;
  }

  function product(p, terms) {
    var t = String(p.title || '');
    var cut = t.search(/\s[-–]\s/);
    var name = cut > 0 ? t.slice(0, cut) : '';
    var desc = cut > 0 ? t.slice(cut + 3) : t;
    var img = p.featured_image && p.featured_image.url || p.image;
    var cmp = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + esc(fmt(p.compare_at_price_max)) + '</s>' : '';
    return '<a class="zm-ss-product" role="option" href="' + esc(p.url) + '">' +
      (img ? '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=140') + '" alt="" width="56" height="70" loading="lazy">' : '<span class="zm-ss-noimg"></span>') +
      '<span class="zm-ss-pbody">' +
        (name ? '<span class="zm-ss-pname">' + mark(name, terms) + '</span>' : '') +
        '<span class="zm-ss-pdesc">' + mark(desc, terms) + '</span>' +
        '<span class="zm-ss-price">' + esc(fmt(p.price)) + cmp + (p.available === false ? '<em>Sold out</em>' : '') + '</span>' +
      '</span></a>';
  }

  function results(res, intent, raw) {
    var terms = (intent.q + ' ' + raw.toLowerCase()).split(/\s+/).filter(function (w, i, all) {
      return w.length > 1 && !/^\d/.test(w) && !/^(under|below|above|over|less|more|than|upto|up|to|within|from|max|min|rs\.?|inr)$/.test(w) && all.indexOf(w) === i;
    });
    var products = (res.products || []).filter(function (p) {
      var n = parseFloat(p.price);
      return (!intent.max || n <= intent.max) && (!intent.min || n >= intent.min);
    }).slice(0, 6);
    var queries = (res.queries || []).filter(function (s) { return s.text.toLowerCase() !== intent.q; }).slice(0, 5);
    var cols = (res.collections || []).slice(0, 4);
    var pages = (res.pages || []).slice(0, 3);
    var notes = [];
    if (intent.fixed) notes.push('Showing results for <b>' + esc(intent.q) + '</b>');
    if (intent.max && intent.min) notes.push('Between ' + esc(fmt(intent.min)) + ' and ' + esc(fmt(intent.max)));
    else if (intent.max) notes.push('Under ' + esc(fmt(intent.max)));
    else if (intent.min) notes.push('Above ' + esc(fmt(intent.min)));

    if (!products.length && !queries.length && !cols.length && !pages.length) {
      return '<div class="zm-ss-empty"><p class="zm-ss-empty-t">Nothing woven for “' + esc(raw) + '” yet.</p>' +
        '<p class="zm-ss-tip">Check the spelling, or try one of these.</p>' +
        (popular.length ? '<div class="zm-ss-chips">' + popular.map(function (t) { return chip(t); }).join('') + '</div>' : '') +
        '<a class="zm-ss-wa" role="option" href="https://wa.me/919909935157?text=' + encodeURIComponent('Hi, I am looking for: ' + raw) + '" target="_blank" rel="noopener" data-no-loader>Ask us on WhatsApp</a></div>';
    }

    var side = '';
    if (queries.length) side += group('Suggestions', queries.map(function (s) {
      return '<a class="zm-ss-q" role="option" href="' + esc(resultsUrl(understand(s.text))) + '" data-save="' + esc(s.text) + '">' + mark(s.text, terms) + '</a>';
    }).join(''));
    if (cols.length) side += group('Collections', cols.map(function (c) {
      return '<a class="zm-ss-q" role="option" href="' + esc(c.url) + '">' + mark(c.title, terms) + '</a>';
    }).join(''));
    if (pages.length) side += group('Help', pages.map(function (c) {
      return '<a class="zm-ss-q" role="option" href="' + esc(c.url) + '">' + mark(c.title, terms) + '</a>';
    }).join(''));

    var main = products.length
      ? group('Sarees', '<div class="zm-ss-products">' + products.map(function (p) { return product(p, terms); }).join('') + '</div>', 'zm-ss-main')
      : group('Sarees', '<p class="zm-ss-tip">No saree in that price. See the full results for more.</p>', 'zm-ss-main');

    return (notes.length ? '<p class="zm-ss-note">' + notes.join(' · ') + '</p>' : '') +
      '<div class="zm-ss-cols' + (side ? '' : ' is-single') + '">' + (side ? '<div class="zm-ss-side">' + side + '</div>' : '') + main + '</div>' +
      '<a class="zm-ss-all" role="option" href="' + esc(resultsUrl(intent)) + '" data-save="' + esc(raw) + '"><span>See all results for “' + esc(raw) + '”</span><span aria-hidden="true">→</span></a>';
  }

  function paint(markup) {
    panel.innerHTML = markup;
    panel.querySelectorAll('[role="option"]').forEach(function (el, i) { el.id = 'zm-ss-o' + i; });
    input.removeAttribute('aria-activedescendant');
  }

  function update() {
    var raw = input.value.trim();
    clearBtn.hidden = !input.value;
    if (raw.length < 2) { form.classList.remove('is-loading'); paint(idle()); return; }
    var intent = understand(raw);
    var mine = ++seq;
    form.classList.add('is-loading');
    suggest(intent.q).then(function (res) {
      var words = intent.q.split(/\s+/);
      if (!(res.products || []).length && words.length > 1) {
        var longest = words.slice().sort(function (a, b) { return b.length - a.length; })[0];
        return suggest(longest).then(function (r2) { return { res: r2, closest: longest }; });
      }
      return { res: res };
    }).then(function (o) {
      if (mine !== seq) return;
      form.classList.remove('is-loading');
      var markup = results(o.res, intent, raw);
      if (o.closest) markup = '<p class="zm-ss-note">No exact match. Closest for <b>' + esc(o.closest) + '</b></p>' + markup;
      paint(markup);
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      if (mine !== seq) return;
      form.classList.remove('is-loading');
      paint('<p class="zm-ss-tip">Suggestions are not loading. Press Enter to see all results.</p>');
    });
  }

  function show() {
    if (!open) {
      open = true;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      update();
    }
  }
  function hide() {
    open = false;
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    html.classList.remove('zm-ss-on');
  }
  function sheet() {
    var menu = document.getElementById('zm-menu');
    if (menu) menu.checked = false;
    html.classList.add('zm-ss-on');
    input.focus();
    show();
  }

  function move(step) {
    var items = Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    if (!items.length) return;
    var now = panel.querySelector('.is-active');
    var i = items.indexOf(now) + step;
    if (i < 0) i = items.length - 1;
    if (i >= items.length) i = 0;
    if (now) { now.classList.remove('is-active'); now.removeAttribute('aria-selected'); }
    items[i].classList.add('is-active');
    items[i].setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', items[i].id);
    items[i].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('focus', show);
  input.addEventListener('input', function () {
    show();
    clearTimeout(timer);
    timer = setTimeout(update, 180);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      show();
      move(e.key === 'ArrowDown' ? 1 : -1);
    } else if (e.key === 'Enter') {
      var active = panel.querySelector('.is-active');
      if (open && active) { e.preventDefault(); active.click(); }
    } else if (e.key === 'Escape') {
      hide();
      input.blur();
    }
  });

  panel.addEventListener('click', function (e) {
    var forget = e.target.closest('.zm-ss-forget');
    if (forget) {
      e.preventDefault();
      try { localStorage.removeItem(KEY); } catch (err) {}
      paint(idle());
      input.focus();
      return;
    }
    var link = e.target.closest('a');
    if (!link) return;
    if (link.dataset.fill) {
      e.preventDefault();
      input.value = link.dataset.fill;
      input.focus();
      update();
      return;
    }
    remember(link.dataset.save || input.value);
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    input.focus();
    update();
  });
  form.querySelector('.zm-ss-close').addEventListener('click', hide);
  document.querySelectorAll('.zm-ss-open').forEach(function (b) { b.addEventListener('click', sheet); });

  form.addEventListener('submit', function (e) {
    var raw = input.value.trim();
    e.preventDefault();
    if (!raw) { input.focus(); return; }
    remember(raw);
    hide();
    var url = resultsUrl(understand(raw));
    if (window.zmLoader) window.zmLoader.show();
    window.location.href = url;
  });

  document.addEventListener('pointerdown', function (e) {
    if (open && !form.contains(e.target) && !mobile.matches) hide();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.defaultPrevented || mobile.matches) return;
    var t = e.target;
    if (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
    e.preventDefault();
    input.focus();
  });
  mobile.addEventListener && mobile.addEventListener('change', hide);

  /* Rotate a few real searches through the placeholder while the box is idle. */
  if (popular.length) {
    var turn = 0;
    setInterval(function () {
      if (document.activeElement === input || input.value) return;
      input.placeholder = 'Search “' + popular[turn++ % popular.length] + '”';
    }, 2800);
  }
})();
